import React, { useEffect, useRef } from 'react'
import { MASTER_ADMINS } from '../config/deploy'
import { Navigate, Outlet } from 'react-router-dom'
import { useRole } from './roles'
import { useToast } from './ToastContext'

export default function RequireRole({ roles = [], children }){
  const { user, role, loading } = useRole()
  const toast = useToast()
  const denied = useRef(false)

  const isMasterAdmin = user && MASTER_ADMINS.includes((user?.email || '').toLowerCase())
  const adminCanSeeAll = isMasterAdmin || role === 'admin'
  const hasAccess = !loading && user && (roles.length === 0 || adminCanSeeAll || (role && roles.includes(role)))

  useEffect(() => {
    if (!loading && user && !hasAccess && !denied.current) {
      denied.current = true
      toast.error('Access denied')
    }
  }, [loading, user, hasAccess, toast])

  if (loading) return null
  if (!user) return <Navigate to="/login" replace />
  if (hasAccess) return children ? children : <Outlet />
  return <Navigate to="/" replace />
}
